var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PeekFormControlLabel, PeekRadio, useTheme } from "@piiqtechnologies/ui-components";
import React from "react";
export const CustomRadio = (_a) => {
    var { isChecked, label, onClick, disabled } = _a, props = __rest(_a, ["isChecked", "label", "onClick", "disabled"]);
    const theme = useTheme();
    return (React.createElement(PeekFormControlLabel, Object.assign({ control: React.createElement(PeekRadio, { size: "small", sx: {
                p: 0.5,
                mx: 0.3,
            } }), checked: isChecked, onClick: onClick, label: label, disabled: disabled, sx: {
            whiteSpace: "nowrap",
            ".MuiRadio-root": {
                color: `${theme.palette.grey[400]} !important`,
            },
            ".Mui-checked": {
                color: `${theme.palette.success.main} !important`,
            },
        } }, props)));
};
export default CustomRadio;
